// @flow
import React, { Component } from "react";
import { Formik, Form, Field } from "formik";
import { stringify } from "querystring";
import Select from "elevate-ui/Select";
import transform from "lodash/transform";
import * as Yup from "yup";

import Effect from "../common/FormikEffect";

type Props = {
  items: Array<Object>,
  query: Object,
  handleSearch: (null | Event, Object) => void,
  className?: Object,
};

class SortOrderForm extends Component<Props> {
  sortForm: any;

  /**
   * Gets rid of filters with empty strings or -1 values
   */
  cleanFilters(values: Object) {
    return transform(
      values,
      (memo, value, key) => {
        if (
          value !== "" &&
          value !== "-1" &&
          (!Array.isArray(value) || value.length)
        ) {
          memo[key] = value;
        }
      },
      {}
    );
  }

  render() {
    const { items, query, className } = this.props;
    return (
      <Formik
        ref={(node) => (this.sortForm = node)}
        initialValues={{
          sortName: query.sortName ? query.sortName : items[0].value,
        }}
        validationSchema={() =>
          Yup.object().shape({
            sortName: Yup.string(),
          })
        }
        onSubmit={() => {}}
        render={() => (
          <Form
            id="sortFilter"
            name="sortFilter"
            noValidate
            method="get"
            style={{ position: "relative", maxWidth: "420px" }}
            className={className}
          >
            <Effect
              onChange={(current, next) => {
                if (
                  stringify(this.cleanFilters(current.values)) !==
                  stringify(this.cleanFilters(next.values))
                ) {
                  const updatedQuery = {
                    ...query,
                    ...next.values,
                  };
                  this.props.handleSearch(
                    null,
                    this.cleanFilters(updatedQuery)
                  );
                }
              }}
            />
            <Field
              id="sortName"
              name="sortName"
              items={items || []}
              component={Select}
              withScaffold={false}
            />
          </Form>
        )}
      />
    );
  }
}

export default SortOrderForm;
